module.exports = __webpack_public_path__ + "img/caption.aa2a4b76.png";